<template>
  <div>
    <div class="d-flex justify-content-between">
      <div
        class="header-progress"
        :style="{width: earlierWidthPercent + '%'}"
      >В прошлые часы:</div>
      <div
        class="header-progress"
        :style="{width: currentWidthPercent + '%'}"
      >Текущий час:</div>
    </div>
    <div
      class="d-flex justify-content-between"
    >
      <b-progress
        height="2rem"
        class=""
        :max="max"
        show-value
        :style="{width: earlierWidthPercent + '%'}"
      >
        <b-progress-bar
          :value="100"
          v-if="earlierData === null"
          variant="dark"
        ></b-progress-bar>
        <template v-if="earlierData !== null && earlierTotalCount > 0">
          <b-progress-bar
            :value="$lodash.get(earlierData, 'inTarget', 0) / earlierTotalCount * 100"
            variant="success"
          ></b-progress-bar>
          <b-progress-bar
            :value="$lodash.get(earlierData, 'outOfTarget', 0) / earlierTotalCount * 100"
            variant="danger"
          ></b-progress-bar>
          <b-progress-bar
            :value="$lodash.get(earlierData, 'notKnown', 0) / earlierTotalCount * 100"
            variant="secondary"
          ></b-progress-bar>
        </template>
      </b-progress>
      <b-progress
        height="2rem"
        class=""
        :max="max"
        show-value
        :style="{width: currentWidthPercent + '%'}"
      >
        <template v-if="currentData !== null && currentTotalCount > 0">
          <b-progress-bar
            :value="$lodash.get(currentData, 'inTarget', 0) / currentTotalCount * 100"
            variant="success"
          ></b-progress-bar>
          <b-progress-bar
            :value="$lodash.get(currentData, 'outOfTarget', 0) / currentTotalCount * 100"
            variant="danger"
          ></b-progress-bar>
          <b-progress-bar
            :value="$lodash.get(currentData, 'notKnown', 0) / currentTotalCount * 100"
            variant="secondary"
          ></b-progress-bar>
        </template>
      </b-progress>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'MonitorTargetProgressbar',
  props: {
    infoStats: {
      type: Object
    }
  },
  data () {
    return {
      lodash: _,
      earlierWidthPercent: 29,
      currentWidthPercent: 69,
      max: 100
    }
  },
  computed: {
    earlierData () {
      return this.$lodash.get(this.infoStats, 'earlierHours')
    },
    currentData () {
      return this.$lodash.get(this.infoStats, 'currentHour')
    },
    earlierTotalCount () {
      return this.earlierData
        ? this.earlierData.inTarget +
        this.earlierData.outOfTarget +
        this.earlierData.notKnown
        : 0
    },
    currentTotalCount () {
      return this.currentData
        ? this.currentData.inTarget +
        this.currentData.outOfTarget +
        this.currentData.notKnown
        : 0
    }
  }
}
</script>

<style scoped>
  .header-progress {
    font-size: 0.8rem;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/containers/workshops/MonitorTargetProgressbar.vue